import browserDetect from 'vue-browser-detect-plugin';
import Vue from 'vue';
Vue.use(browserDetect);

const vue = new Vue();

const compatibleBrowsers = [
  {name: 'Edge', minimalVersion: 17},
  {name: 'Firefox', minimalVersion: 64},
  {name: 'Chrome', minimalVersion: 70},
  {name: 'Safari', minimalVersion: 11},
  {name: 'Opera', minimalVersion: 57},
];

export const isEdgeOrFirefox = () => {
  return (vue as any).$browserDetect.isEdge || (vue as any).$browserDetect.isFirefox;
};
